import React from 'react'
import clsx from 'clsx'
import { useDrag, useDrop } from 'react-dnd'
import { MdDragHandle } from 'react-icons/md'
import { useTheme } from '@mui/material'
import { CloseCircle } from 'iconsax-react'

import useBaseStyles from '../AnswerSection/styles'

import useStyles from './styles'

const ITEM_TYPE = 'INBOX_CHIP'

const InboxChip = ({
  id,
  item,
  inboxes,
  questionIndex,
  answer,
  handleMoveAnswerInbox,
  handleRemoveAnswerInbox
}) => {
  const theme = useTheme()
  const dragRef = useDrag({
    item: { type: ITEM_TYPE, id }
  })[1]

  const [{ isOver: isOverTop }, dropTop] = useDrop({
    accept: ITEM_TYPE,
    drop: item =>
      handleMoveAnswerInbox(item.id, id, answer.value, questionIndex),
    collect: monitor => ({
      isOver: !!monitor.isOver()
    })
  })

  const [{ isOver: isOverBottom }, dropBottom] = useDrop({
    accept: ITEM_TYPE,
    drop: item =>
      handleMoveAnswerInbox(item.id, id, answer.value, questionIndex),
    collect: monitor => ({
      isOver: !!monitor.isOver()
    })
  })

  const chipClasses = useStyles()
  const classes = useBaseStyles({
    isOverTop,
    isOverBottom
  })

  const value = inboxes?.find(x => x.id === item)?.name || ''

  return (
    <div className={clsx(classes.root, chipClasses.chip)}>
      <div ref={dragRef} className={classes.drag}>
        <MdDragHandle />
      </div>
      <div ref={dropTop} className={clsx(classes.drop, classes.dropTop)} />

      <div
        ref={dropBottom}
        className={clsx(classes.drop, classes.dropBottom)}
      />

      <label title={value} className={chipClasses.label}>
        {value}
      </label>

      <CloseCircle
        size={theme.size.base}
        className='delete'
        onClick={() => {
          handleRemoveAnswerInbox(answer.value, item, questionIndex)
        }}
      />
    </div>
  )
}

export default InboxChip
